"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.channels = exports.channelKeyToParts = void 0;
const enums_1 = require("../enums");
const DELIMITER = "-";
const dash = (list) => list.filter(k => k).join(DELIMITER);
/**
 * Pulls out the domain, entityId, and qualifiers from a channel key.
 *
 * Eg, input: club-123-comments
 * output: { domain: "club", entityId: 123, qualifer: ["comments"]}
 */
const channelKeyToParts = (key) => {
    const parts = key.split(DELIMITER);
    return parts.reduce((acc, cur) => {
        if (Object.values(enums_1.ChannelDomains).some(d => d === cur)) {
            return Object.assign(Object.assign({}, acc), { domain: cur });
        }
        else if (Object.values(enums_1.ChannelQualifiers).some(d => d === cur)) {
            return Object.assign(Object.assign({}, acc), { qualifier: [...(acc.qualifier || []), cur] });
        }
        else {
            return Object.assign(Object.assign({}, acc), { entityId: cur });
        }
    }, {});
};
exports.channelKeyToParts = channelKeyToParts;
/**
 * channels
 *
 * Predefined notification channels
 *
 * @returns String that uniquely identifies a notificaiton channel
 */
exports.channels = {
    [enums_1.ChannelDomains.club]: {
        /**
         * posts from a given club
         */
        [enums_1.ChannelQualifiers.posts]: (clubId) => dash([enums_1.ChannelDomains.club, clubId, enums_1.ChannelQualifiers.posts]),
        /**
         * membership updates from a given club
         */
        [enums_1.ChannelQualifiers.membership]: (clubId) => dash([enums_1.ChannelDomains.club, clubId, enums_1.ChannelQualifiers.membership]),
        /**
         * notifications that only send to mods / admins
         */
        [enums_1.ChannelQualifiers.admin]: (clubId) => dash([enums_1.ChannelDomains.club, clubId, enums_1.ChannelQualifiers.admin]),
    },
    /**
     * activity from a given event
     */
    [enums_1.ChannelDomains.event]: {
        /**
         * Scheduling notifications for an event
         */
        [enums_1.ChannelQualifiers.scheduling]: (eventId) => dash([enums_1.ChannelDomains.event, eventId, enums_1.ChannelQualifiers.scheduling]),
        /**
         * membership updates from a given club
         */
        [enums_1.ChannelQualifiers.recommendations]: (eventId) => dash([enums_1.ChannelDomains.event, eventId, enums_1.ChannelQualifiers.recommendations]),
        /**
         * Invites to an event
         */
        [enums_1.ChannelQualifiers.invites]: (eventId) => {
            if (!eventId) {
                return dash([enums_1.ChannelDomains.event, enums_1.ChannelQualifiers.invites]);
            }
            return dash([enums_1.ChannelDomains.event, eventId, enums_1.ChannelQualifiers.invites]);
        }
    },
    /**
     * chat messages from a given user
     */
    [enums_1.ChannelDomains.message]: (profileId) => dash([enums_1.ChannelDomains.message, profileId]),
    /**
     * mentions from a given user
     */
    [enums_1.ChannelDomains.mention]: (profileId) => dash([enums_1.ChannelDomains.mention, profileId]),
    /**
     * activity from a given post
     */
    [enums_1.ChannelDomains.post]: (postId) => dash([enums_1.ChannelDomains.post, postId]),
    /**
     * people following you
     */
    [enums_1.ChannelDomains.followers]: () => `${enums_1.ChannelDomains.followers}`,
    /**
     * people commenting on your posts, or posts you've commented on
     */
    [enums_1.ChannelDomains.comments]: () => `${enums_1.ChannelDomains.comments}`,
    /**
     * people messaging you
     */
    [enums_1.ChannelDomains.messages]: () => `${enums_1.ChannelDomains.messages}`,
    /**
     * people mentioning
     */
    [enums_1.ChannelDomains.mentions]: () => `${enums_1.ChannelDomains.mentions}`,
    /**
     * people liking your activity
     */
    [enums_1.ChannelDomains.likes]: () => `${enums_1.ChannelDomains.likes}`,
    /**
     * admin notifications, generally system notices or notices from Tonit
     */
    [enums_1.ChannelDomains.admin]: () => `${enums_1.ChannelDomains.admin}`,
    /**
     * admin notifications, generally system notices or notices from Tonit
     */
    [enums_1.ChannelDomains.clubinvites]: () => `${enums_1.ChannelDomains.clubinvites}`,
    /**
     * notifications relating to this user (either post owner, comment owner, event owner etc.)
     */
    [enums_1.ChannelDomains.user]: (profileId) => dash([enums_1.ChannelDomains.user, profileId]),
};
